'use es6';

import { createSelectorCreator, defaultMemoize } from 'reselect';
export const createUnmemoizedSelector = createSelectorCreator(defaultMemoize, () => false // defaultMemoize uses this to determine arg equality
);